/* global $ */

(function (scope) {
  "use strict";

  /**
   *
   */
  var PrintModalReviewView = (scope.PrintModalReviewView = function (
    controller,
    design,
    printIframePageUrl
  ) {
    this.controller = controller;
    this.design = design;
    this.printIframePageUrl = printIframePageUrl;

    this.$el = $("#PrintModalReviewView");

    this.$el.on("click", ".modal-background", this.hideModal.bind(this));
    this.$el.on("click", ".modal-checkout", this.checkout.bind(this));
    this.$el.on("click", ".modal-back", this.Back.bind(this));
  });

  /**
   * Hide modal review
   * @public
   */
  PrintModalReviewView.prototype.hideModal = function (e) {
    this.$el.hide();

    //empty the iframe
    $(".iframe-render-model", this.$el).prop("src", "");
  };

  /**
   * Show the modal of review
   * @public
   * @param {TOOLS}
   */
  PrintModalReviewView.prototype.showModal = function () {
    this.$el.show();

    //add a nice loading circle until the iframe is loaded
    $(".intrinsic-container", this.$el).addClass("loading-circle");

    //set the url based on the design
    var url = this.printIframePageUrl;
    url += this.design.slug;
    url += "/";
    url += this.design.design_uuid;
    url += "?uuid=" + this.design.model_uuid;
    url += "&soliditycheck=true";

    //set the iframe src
    $(".iframe-render-model", this.$el).prop("src", url);

    //when it is loaded removed the loading circle
    $(".iframe-render-model", this.$el).load(
      function () {
        $(".intrinsic-container", this.$el).removeClass("loading-circle");
      }.bind(this)
    );
  };

  /**
   * Hide modal tool
   * @private
   */
  PrintModalReviewView.prototype.Back = function (e) {
    this.hideModal(e);
    this.controller.views.toolbar.changeView(
      sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK
    );
  };

  /**
   * checkout
   * @private
   */
  PrintModalReviewView.prototype.checkout = function (e) {
    this.hideModal(e);
    this.controller.addToCart();
  };
})((window.sculpteo = window.sculpteo || {}));
